export const LOGIN_URL = '/api/login'
export const LOGOUT_URL = '/api/logout'
export const CSRF_TOKEN_URL = '/api/sanctum/csrf-cookie'
export const GET_USER_URL = '/api/v1/user'
export const TWO_FA_CHECK_URL = '/api/loginTwoFactor'
export const UPDATE_USER_URL = 'api/v1/user/update-account-details'
